import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from "react";
import { useFormikContext } from "formik";
const LogFormikErrors = () => {
    const formik = useFormikContext();
    useEffect(() => {
        if (!formik.isValid) {
            console.debug('Formik Errors', formik.errors);
        }
    }, [formik]);
    return _jsx(_Fragment, {});
};
export default LogFormikErrors;
//# sourceMappingURL=index.js.map